// src/redux/orgSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeOrgId: null,
  permittedModules: []
};

const orgSlice = createSlice({
  name: 'org',
  initialState,
  reducers: {
    setActiveOrgId(state, action) {
      state.activeOrgId = action.payload;
    },
    setPermittedModules(state, action) {
      state.permittedModules = action.payload;
    }
  }
});

export const { setActiveOrgId, setPermittedModules } = orgSlice.actions;
export default orgSlice.reducer;